import React, { useEffect, useState, useRef } from 'react'
import Api from '../../../_helpers/Api'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { trans } from '../../../_providers/Translation'

import FilterTabs from './partials/FilterTabs'
import Skeleton from 'react-loading-skeleton'
import Invoices from './invoices/Index'
import Parts from './parts/Index'
import loader from '../../../assets/img/loader.svg'
import Reservations from './reservations/Index'
import Mails from './mails/Index'
import Stats from './stats/Index'
import Files from './files/Index'

function Contractor(props) {

    const location = useLocation()
    const history = useHistory()
    const params = useParams()

    const searchParams = new URLSearchParams(location.search)

    const tabs = [
        {
            id: 'reservations',
            name: trans('tabs.reservations'),
            component: Reservations
        },
        {
            id: 'invoices',
            name: trans('tabs.invoices'),
            component: Invoices
        },
        {
            id: 'parts',
            name: trans('tabs.contractorParts'),
            component: Parts
        },
        {
            id: 'files',
            name: trans('tabs.files'),
            component: Files,
            hasRef: true
        },
        {
            id: 'mails',
            name: trans('tabs.history'),
            component: Mails
        },
        {
            id: 'stats',
            name: trans('tabs.stats'),
            component: Stats
        },
    ]

    const tab = searchParams.get('tab') ? searchParams.get('tab') : tabs[0].id

    const componentRef = useRef(null)

    const [state, setState] = useState({
        tab: tabs[0].id,
        index: 0,
        loading: true,
        data: null
    })

    useEffect(() => {

        setState(prev => ({
            ...prev,
            loading: true,
            tab: tab,
            index: findTabIndex(tab)
        }))

        Api.get('contractors/find?id=' + params.id)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data
                }))
            })
            .finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }, [])

    const handleTab = id => {

        let index = findTabIndex(id)

        setState(prev => ({
            ...prev,
            tab: id,
            index: index
        }))

        history.push('?tab=' + id)
    }

    const findTabIndex = id => {
        let index = tabs.findIndex(t => {
            return t.id === id
        })

        return index
    }

    const handleAdd = () => {
        let modal = componentRef.current

        if (modal) {
            modal.add()
        }
    }

    const handleAddInvoice = () => {
        history.push('/accounting/add', { contractor: state.data })
    }

    return (
        <>

            <div className="wrapper">
                {state.loading
                    ?
                    <img src={loader} alt="loading" />
                    :
                    <>
                        <div className="top-part">
                            <div className="left">
                                <h1 className="page-heading">
                                    {state.data && state.data.name}
                                </h1>
                                <p className="page-subheading">
                                    {trans('subheadings.contractors')}
                                </p>
                            </div>
                            {tabs[state.index] && tabs[state.index].hasRef
                                ?
                                <div className="right">
                                    <button
                                        className="button-add"
                                        onClick={handleAdd}
                                    >
                                        {trans('buttons.add')}
                                    </button>
                                </div>
                                :
                                ''
                            }
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                position: "relative",
                            }}
                        >
                            <FilterTabs
                                tabs={tabs}
                                tab={state.tab}
                                handleTab={handleTab}
                            />
                            <button
                                className="button-add button-small"
                                onClick={handleAddInvoice}
                                style={{
                                    position: "absolute",
                                    right: 0,
                                    marginBottom: "20px",
                                }}
                            >
                                {trans("buttons.invoice")}
                            </button>
                        </div>
                        {tabs[state.index] &&
                            React.createElement(tabs[state.index].component, {
                                ref: componentRef
                            })
                        }
                    </>
                }
            </div>

        </>
    )
}

export default Contractor